import { AnalyticsService } from '$lib/services/analytics';
import { startLoading } from '$lib/stores/app/actions';
import { getSubscriptionInfo } from '$lib/stores/subscription/action';
import { SUBSCRIPTION_STATUS } from '$lib/stores/subscription/constants';
import { validateUser } from '$lib/stores/user/action';
import { ACCOUNT_STATUS } from '$lib/stores/user/constants';
import { user } from '$lib/stores/user/store';
import { AOFL_PRODUCT_NAMES, AOFL_PRODUCT_UUIDS, QUERY_PARAM_KEYS } from '$lib/utils/constants';
import { get } from 'svelte/store';
import { SUBSCRIPTION_CATEGORY } from '../../../routes/cancel-subscription/__modules/constants';
import { ProductExperienceService } from '../product-experience';

// TODO: type of all these and other page based policies

export const ALLOW_ALL_NO_VALIDATE = async () => {
	return true;
};

export const ACTIVE_USERS_ONLY = async () => {
	try {
		await validateUser({ force: false });
		const { accountStatus, tokenValid } = get(user);
		return tokenValid && accountStatus === ACCOUNT_STATUS.ACTIVE;
	} catch (error) {
		AnalyticsService.trackClientDebug({
			eventSubType: 'auth-policies',
			source: 'ACTIVE_USERS_ONLY',
			error: error
		});
		return false;
	}
};

export const ALLOW_ALL = async () => {
	try {
		await validateUser({ force: false });
		return true;
	} catch (error) {
		AnalyticsService.trackClientDebug({
			eventSubType: 'auth-policies',
			source: 'ALLOW_ALL',
			error: error
		});
		return false;
	}
};

export const CANCELLED_USERS_ONLY = async () => {
	try {
		await validateUser({ force: false });
		const { accountStatus, tokenValid } = get(user);
		return (
			tokenValid &&
			[ACCOUNT_STATUS.INACTIVE, ACCOUNT_STATUS.AUXILIARY_ONLY_ACTIVE].includes(accountStatus)
		);
	} catch (error) {
		AnalyticsService.trackClientDebug({
			eventSubType: 'auth-policies',
			source: 'CANCELLED_USERS_ONLY',
			error: error
		});
		return false;
	}
};

export const VALID_FREE_OR_INACTIVE_USERS_ONLY = async () => {
	try {
		const { accountStatus, tokenValid } = get(user);
		return (
			tokenValid &&
			(ACCOUNT_STATUS.FREE === accountStatus || ACCOUNT_STATUS.INACTIVE === accountStatus)
		);
	} catch (error) {
		AnalyticsService.trackClientDebug({
			eventSubType: 'auth-policies',
			source: 'VALID_FREE_OR_INACTIVE_USERS_ONLY',
			error: error
		});
		return false;
	}
};

export const LOGGED_OUT_USERS_ONLY = async () => {
	try {
		await validateUser({ force: false });
		const currentUser = get(user);
		return !currentUser.tokenValid;
	} catch (error) {
		AnalyticsService.trackClientDebug({
			eventSubType: 'auth-policies',
			source: 'LOGGED_OUT_USERS_ONLY',
			error: error
		});
		return false;
	}
};

export const LOGGED_IN_USERS_ONLY = async () => {
	try {
		await validateUser({ force: false });
		const currentUser = get(user);

		return currentUser.tokenValid;
	} catch (error) {
		AnalyticsService.trackClientDebug({
			eventSubType: 'auth-policies',
			source: 'LOGGED_IN_USERS_ONLY',
			error: error
		});
		return false;
	}
};

export const VALID_PARENT_SECTION_USERS = async () => {
	try {
		const url = new URL(window?.location?.href);
		const token = url.searchParams.get(QUERY_PARAM_KEYS.TOKEN);
		const productUuid =
			url.searchParams.get(QUERY_PARAM_KEYS.PRODUCT_UUID) ||
			ProductExperienceService.AOFL_PRODUCT_UUID;

		const productName =
			productUuid === AOFL_PRODUCT_UUIDS.ABCMOUSE_2_0
				? AOFL_PRODUCT_NAMES.ABCMOUSE_2_0
				: AOFL_PRODUCT_NAMES.ABCMOUSE;

		ProductExperienceService.setProductExperience(productName);

		await validateUser({ forceIntrospect: !!token });
		const currentUser = get(user);

		return currentUser.tokenValid;
	} catch (error) {
		return false;
	}
};

export const VALID_CANCEL_SUBSCRIPTION_USERS = async () => {
	await validateUser({ force: false });
	const currentUser = get(user);
	const isUserValid = currentUser.tokenValid;

	const url = new URL(window?.location?.href);
	const subscriptionCategory =
		url.searchParams.get(QUERY_PARAM_KEYS.SUBSCRIPTION_CATEGORY) || SUBSCRIPTION_CATEGORY.PRIMARY;

	// Get the subscription UUID for the subscription category
	const foundAccount = currentUser?.aoflProducts?.find((/** @type {any} */ account) => {
		return account.subscriptionPlanCategory === subscriptionCategory;
	});

	const subscriptionUuid = foundAccount?.subscriptionUuid ?? '';

	const { data } = await getSubscriptionInfo({ subscription_uuid: subscriptionUuid });

	const isSubscriptionActive = data?.subscription_status === SUBSCRIPTION_STATUS.ACTIVE;

	return isUserValid && isSubscriptionActive;
};

export const VALID_SUPPORT_CHATBOT_USERS = async () => {
	try {
		startLoading();
		const url = new URL(window?.location?.href);
		const token = url.searchParams.get(QUERY_PARAM_KEYS.TOKEN);
		const productUuid =
			url.searchParams.get(QUERY_PARAM_KEYS.PRODUCT_UUID) ||
			ProductExperienceService.AOFL_PRODUCT_UUID;

		const productName =
			productUuid === AOFL_PRODUCT_UUIDS.ABCMOUSE_2_0
				? AOFL_PRODUCT_NAMES.ABCMOUSE_2_0
				: AOFL_PRODUCT_NAMES.ABCMOUSE;

		ProductExperienceService.setProductExperience(productName);

		await validateUser({ forceIntrospect: !!token });
		const currentUser = get(user);

		return currentUser.tokenValid;
	} catch (error) {
		AnalyticsService.trackClientDebug({
			eventSubType: 'auth-policies',
			source: 'VALID_PARENT_SECTION_USERS',
			error: error
		});
		return false;
	}
};
